import { FilterParams, InvoiceNumberSequence } from '@synergy/models';
import { FormattedMessage } from 'react-intl';
import { PaloThemeProvider, tokens } from '@synergy/theme-palo';
import { ReactElement } from 'react';
import { Tab, Tabs } from '@mui/material';
import { useFilter } from '@synergy/components';

export interface PaloInvoiceNumberSequenceFilterProps {
    numberSequences?: InvoiceNumberSequence[];
}

/**
 * PALO number-sequence tabs (Alle / prefix …) over the legacy filter context,
 * matching the invoice list. Replaces the legacy segmented button toggle.
 */
export const PaloInvoiceNumberSequenceFilter = ({
    numberSequences = [],
}: PaloInvoiceNumberSequenceFilterProps): ReactElement => {
    const { filter, updateFilter } = useFilter();
    const active = filter.get(FilterParams.InvoiceNumberSequenceId) ?? 'all';

    const onSelect = (value: string): void => {
        filter.delete(FilterParams.InvoiceNumberSequenceId);
        if (value !== 'all') {
            filter.set(FilterParams.InvoiceNumberSequenceId, value);
        }
        updateFilter(filter);
    };

    return (
        <PaloThemeProvider>
            <Tabs
                value={active}
                onChange={(_, value) => onSelect(value)}
                variant="scrollable"
                scrollButtons="auto"
                sx={{ mb: 2, borderBottom: `1px solid ${tokens.color.line}` }}
            >
                <Tab value="all" label="Alle" />
                {numberSequences.map(sequence => (
                    <Tab
                        key={sequence.id}
                        value={String(sequence.id)}
                        label={sequence.prefix ?? <FormattedMessage id="app.filter.invoiceNumberSequenceStandard" />}
                    />
                ))}
            </Tabs>
        </PaloThemeProvider>
    );
};
